<script>
  import {STATISTICS}       from '../../../constants/statistics';
  import HelpButton         from '../../help-button/help-button.svelte';
  import AllScoresFilter    from './all-scores-filter/all-scores-filter.svelte';
  import ScoreFiltersLegend from './score-filters-legend/score-filters-legend.svelte';
  import StatFilter         from './stat-filter/stat-filter.svelte';

  const helps = {
    scoreFilters: {
      topic: 'Filter by Statistics',
      description: 'Click the statistic values you want your vehicle to have. This will filter your Results below.'
    }
  };
</script>

<style>
  #score-filters h2 {
    margin-bottom: 10px;
  }

  #score-filters :global(.filter-name) {
    width: 154px;
  }

  /* shared by StatFilterScore, available/selected indicators */
  #score-filters :global(.score-box) {
    background-color: #ddd;
    box-sizing: border-box;
    color: #333;
    height: 21px;
    margin: 0;
    padding: 0;
    vertical-align: middle;
    width: 21px;
  }

  #score-filters :global(.border-bottom-strong) { border-bottom: 1px solid #333; }
  #score-filters :global(.border-left-strong)   { border-left:   1px solid #333; }
  #score-filters :global(.border-right-strong)  { border-right:  1px solid #333; }
  #score-filters :global(.border-top-strong)    { border-top:    1px solid #333; }

  #score-filters :global(.stat-score-disabled) {
    background-color: #777;
  }

  #score-filters :global(.stat-score-highlighted) {
    background-color: #feea32; /* matched to game screenshot */
  }
</style>

<template lang="pug" src="./score-filters.pug"></template>
